import { gql } from "lib/apolloClient";
import {
  unitFlowFragment,
  unitResourceFragment,
  unitFlowFragmentWithoutDepth,
} from "./Fragments";

export const createEntityFlowResourceMutation = gql`
  mutation createEntityFlowResource(
    $input: CreateLearningCourseFlowResourceInput!
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      createLearningCourseFlowResource(input: $input) {
        ...unitFlowWithChildrenItem
      }
    }
  }
  ${unitFlowFragmentWithoutDepth.unitFlowWithChildren}
`;

export const reorderEntityFlowResourceMutation = gql`
  mutation reorderEntityFlowResource(
    $input: ReorderLearningCourseFlowResourceInput!
  ) {
    planner {
      reorderLearningCourseFlowResource(input: $input)
    }
  }
`;

export const updateEntityFlowResourceMutation = gql`
  mutation updateEntityFlowResource(
    $input: UpdateLearningCourseFlowResourceInput!
  ) {
    planner {
      updateLearningCourseFlowResource(input: $input) {
        id
      }
    }
  }
`;

export const deleteEntityFlowResourceMutation = gql`
  mutation deleteEntityFlowResource(
    $input: DeleteLearningCourseFlowResourceInput!
  ) {
    planner {
      deleteLearningCourseFlowResource(input: $input)
    }
  }
`;

export const repeatEntityFlowResourceMutation = gql`
  mutation repeatEntityFlowResource(
    $input: RepeatLearningCourseFlowResource!
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      repeatLearningCourseFlowResource(input: $input) {
        isSuccess
        error
        courseFlowResource {
          ...unitFlowWithChildrenItem
        }
      }
    }
  }
  ${unitFlowFragment.unitFlowWithChildren}
`;

export const importEntityFlowResourceMutation = gql`
  mutation importEntityFlowResource(
    $input: ImportLearningCourseFlowResourceInput!
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      importLearningCourseFlowResource(input: $input) {
        isSuccess
        error
        courseFlowResource {
          ...unitFlowWithChildrenItem
        }
      }
    }
  }
  ${unitFlowFragment.unitFlowWithChildren}
`;

export const createUnitResourceMutation = gql`
  mutation createEntityFlowResource($input: EntityFlowResourceCreateInput!) {
    planner {
      createEntityFlowResource(input: $input) {
        ...unitResourceItem
      }
    }
  }
  ${unitResourceFragment}
`;

export const updateLockedStateMutation = gql`
  mutation updateLockedState($input: LearningCourseEntityLockUpdateInput!) {
    planner {
      bulkUpdateLearningCourseEntityLock(input: $input) {
        isSuccess
      }
    }
  }
`;

export const shareEntityFlowResourceMutation = gql`
  mutation shareCourseFlowResource(
    $input: ShareLearningCourseFlowResourceInput!
  ) {
    planner {
      shareLearningCourseFlowResource(input: $input)
    }
  }
`;
